import React, { useState, useEffect, useRef } from 'react';
import './CheckAnimation.css';

export default function CheckReveal({ visible, setVisible, hasWidth, setHasWidth, size = 30 }) {
  const checkMaskRef = useRef(null);
  const didMountRef = useRef(false);
  const debounceRef = useRef(null); // stores timeout id
  const isAnimatingRef = useRef(false);
  const hasRevertedRef = useRef(false);

  const ANIMATION_DURATION = 1800; // ms — match your CSS animation duration

  useEffect(() => {
    const el = checkMaskRef.current;
    if (!el) return;

    // On first mount: just set state, no animation
    if (!didMountRef.current) {
      el.classList.remove('animate', 'animate-hide');
      if (visible) { el.classList.add('animate'); }
      didMountRef.current = true;
      return;
    }

    // If already animating, cancel and revert only once
    if (isAnimatingRef.current) {
      if (!hasRevertedRef.current) {
        hasRevertedRef.current = true;
        setVisible(prev => !prev); // revert the toggle
      }
      return;
    }

    // Reset revert flag (safe to update state now)
    hasRevertedRef.current = false;
    triggerAnimation(visible);
  }, [visible]);

  const triggerAnimation = (shouldShow) => {
    const el = checkMaskRef.current;
    if (!el) return;

    el.classList.remove('animate', 'animate-hide');
    void el.offsetWidth; // force reflow

    if (shouldShow) {
      setHasWidth(prev => true);
      el.classList.add('animate');
    } else {
      el.classList.add('animate-hide');
      setTimeout(()=>{ setHasWidth(prev => false); }, ANIMATION_DURATION);
    }

    // Set animating flag
    isAnimatingRef.current = true;
    setTimeout(() => {
      isAnimatingRef.current = false;
    }, ANIMATION_DURATION);
  };

  return (
    <div className="check-wrapper">
      <div ref={checkMaskRef} className="check-mask">
        <svg
          className="green-check"
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="#52d13b"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
    </div>
  );
}

